exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".drag {\n  background-color: red; }\n\n.el #abc {\n  display: none; }\n\n.littelPad {\n  padding-left: 30px;\n  font-style: italic; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/module/project/panelP/panelP.component.scss
// module id = 466
// module chunks = 0